export default {
    en: {
        general: {
        },
    },
};
